import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import useIsMobile from '../hooks/useIsMobile';

function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const isMobile = useIsMobile();

  const token = new URLSearchParams(window.location.search).get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }
    if (password !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    setLoading(true);
    try {
      const { data } = await api.post('/auth/reset-password', { token, password });
      if (data.success) {
        setSuccess(true);
      } else {
        setError(data.error || 'Error al restablecer contraseña');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Error de conexión');
    }
    setLoading(false);
  };

  if (!token) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        backgroundColor: '#f9fafb', padding: '1rem',
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0
      }}>
        <div style={{
          maxWidth: '28rem', width: '100%', backgroundColor: 'white',
          borderRadius: '0.5rem', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
          padding: '2rem', textAlign: 'center'
        }}>
          <p style={{ color: '#991b1b', marginBottom: '1.5rem', fontSize: '1rem' }}>El enlace es inválido o ha expirado.</p>
          <Link to="/forgot-password" style={{ fontWeight: '500', color: '#ff8c00', textDecoration: 'none' }}>
            Solicitar un nuevo enlace
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      backgroundColor: '#f9fafb', padding: isMobile ? '1rem 0.75rem' : '3rem 1rem',
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, overflow: 'auto'
    }}>
      <div style={{
        maxWidth: '28rem', width: '100%', backgroundColor: 'white',
        borderRadius: '0.5rem', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
        padding: isMobile ? '1.5rem 1rem' : '2rem'
      }}>
        <div style={{ textAlign: 'center', marginBottom: isMobile ? '1.5rem' : '2rem' }}>
          <img src="/logo.png" alt="EnvíaTuPaquete.mx"
            style={{ margin: '0 auto', height: isMobile ? '8rem' : '15rem', marginBottom: '0.5rem' }} />
          <h2 style={{ fontSize: isMobile ? '1.5rem' : '1.875rem', fontWeight: 'bold', color: '#111827' }}>
            Nueva contraseña
          </h2>
          <p style={{ marginTop: '0.5rem', color: '#6b7280', fontSize: isMobile ? '0.875rem' : '1rem' }}>
            Ingresa tu nueva contraseña
          </p>
        </div>

        {error && (
          <div style={{
            backgroundColor: '#fef2f2', border: '1px solid #fecaca', color: '#991b1b',
            padding: '0.75rem 1rem', borderRadius: '0.375rem', marginBottom: '1rem', fontSize: '0.875rem'
          }}>{error}</div>
        )}

        {success ? (
          <div>
            <div style={{
              backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0', color: '#166534',
              padding: '1rem', borderRadius: '0.375rem', marginBottom: '1.5rem', fontSize: '0.95rem', lineHeight: '1.6'
            }}>
              Tu contraseña ha sido actualizada exitosamente.
            </div>
            <div style={{ textAlign: 'center' }}>
              <Link to="/login" style={{
                display: 'inline-block', padding: '0.75rem 2rem', backgroundColor: '#ff8c00',
                color: 'white', textDecoration: 'none', borderRadius: '0.375rem', fontWeight: '600', fontSize: '1rem'
              }}>
                Ir al inicio de sesión
              </Link>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
            <div>
              <label htmlFor="password" style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.25rem' }}>Nueva contraseña</label>
              <input id="password" type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ width: '100%', padding: '0.625rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '1rem', outline: 'none', boxSizing: 'border-box' }}
                placeholder="Mínimo 6 caracteres" />
            </div>
            <div>
              <label htmlFor="confirmPassword" style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.25rem' }}>Confirmar contraseña</label>
              <input id="confirmPassword" type="password" required value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                style={{ width: '100%', padding: '0.625rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '1rem', outline: 'none', boxSizing: 'border-box' }}
                placeholder="Repite tu contraseña" />
            </div>
            <button type="submit" disabled={loading} style={{
              width: '100%', padding: '0.75rem 1rem', backgroundColor: loading ? '#fed7aa' : '#ff8c00',
              color: 'white', fontWeight: '600', borderRadius: '0.375rem', border: 'none',
              cursor: loading ? 'not-allowed' : 'pointer', fontSize: '1rem', transition: 'background-color 0.2s'
            }}>{loading ? 'Actualizando...' : 'Restablecer contraseña'}</button>
          </form>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
